import { genericId } from '@cnx-saas/utils-cnx-id';
import { BaseSchema } from '../types';

export const fakeBaseFactory = {
  createBaseSchema: (baseSchema: Partial<BaseSchema> = {}): BaseSchema => ({
    id: genericId(),
    createdAt: new Date(),
    updatedAt: new Date(),
    ...baseSchema,
  }),
};

export const fakeBaseSchema = fakeBaseFactory.createBaseSchema();
